import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

const HEARTBEAT_INTERVAL = 10000; // 10 seconds

export function useHeartbeat(playerId: string | null, roomId: string | null) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!playerId || !roomId) return;

    const sendHeartbeat = async () => {
      try {
        await supabase
          .from('players')
          .update({ last_activity: new Date().toISOString() })
          .eq('id', playerId);
      } catch (error) {
        // Silently fail - connection issues are handled elsewhere
      }
    };

    // Send initial heartbeat
    sendHeartbeat();

    // Set up interval
    intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [playerId, roomId]);
}
